// Helper to standardize Medical Billing Summary analytics tracking.
// Hides boilerplate such as suppressing property inheritance.

import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { getTrackEventGlobal } from '@/analytics/utils/analytics-helpers'
import type { TrackEventFn } from '@/analytics/hooks/useAnalytics'

/**
 * Track a Medical Billing Summary specific analytics event.
 * Automatically applies { suppressFeatureInheritance: true } so that no
 * residual properties from previous events leak into this payload.
 */
export function trackMedSummaryEvent(
  event: AnalyticsEvent,
  props: Record<string, string | number | boolean>,
  track: TrackEventFn | undefined = getTrackEventGlobal()
) {
  if (!track) return
  track(event, props, {
    suppressFeatureInheritance: true,
  })
}
